import { Mesh, Vector3 } from "three";
import { ICollidable } from "../../../../../../three/physics/ICollidable";
import { GameViewModel } from "../../../../models/GameViewModel";
import { IProjectileContainer } from "../../gamefield/IProjectileContainer";
import { BaseMole } from "../../gamefield/mole/BaseMole";
import { Level } from "../../Level";
import { ExplosionParticle } from "../../gamefield/particles/ExplosionParticle";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { BatchedRenderer } from "three.quarks";
import { Box } from "../../gamefield/box/Box";
import { AudioController, Sfx } from "../../../AudioController";
import { CharacterProjectile } from "./CharacterProjectile";
import { ExplosionAreaParticle } from "../../gamefield/particles/ExplosionAreaParticle";

export class Dynamite extends CharacterProjectile {
    private activated: boolean;
    public constructor(
        projectileContainer: IProjectileContainer,
        gameResources: GameResourcesPackage,
        private readonly audioController: AudioController,
        private readonly particlesBatchRenderer: BatchedRenderer,
        private readonly gameViewModel: GameViewModel,
        protected readonly weaponMesh: Mesh,
        protected readonly speed: number,
    ) {
        super(gameResources, particlesBatchRenderer, projectileContainer, weaponMesh, speed, 200);
        this.activated = false;
    }

    public override onCollision(other: ICollidable): void {
        if (this.activated || !this.thrown) {
            return;
        }

        if (other instanceof BaseMole || other instanceof Box || other instanceof Level) {
            this.activated = true;

            const activatedPosition = this.getWorldPosition(new Vector3());

            const explosionParticle = new ExplosionParticle(this.gameResources, this.particlesBatchRenderer);
            explosionParticle.scale.set(1.5, 1.5, 1.5);
            explosionParticle.position.set(activatedPosition.x, 0.2, activatedPosition.z);
            this.parent.add(explosionParticle);

            const areaParticle = new ExplosionAreaParticle(this.gameResources, this.particlesBatchRenderer);
            areaParticle.position.set(activatedPosition.x, 0.02, activatedPosition.z);
            this.parent.add(areaParticle);

            this.audioController.playSfx(Sfx.Explosion);

            const itemsInRadius = [
                ...this.gameViewModel.getAliveMolesInRadius(this.position, 5),
                ...this.gameViewModel.getAvailableBoxesInRadius(this.position, 5)
            ];
            for (const item of itemsInRadius) {
                item.takeDamage(200);
            }
            this.destroy();
        }
    }

    protected override onTick(dt: number): void {
        this.rotate(dt);
        super.onTick(dt);
    }

    private rotate(dt: number): void {
        const spinAxis = new Vector3(Math.random(), Math.random(), Math.random()).normalize();
        const spinSpeed = Math.random() * 2 + 1;
        this.weaponMesh.rotateOnAxis(spinAxis, spinSpeed * dt);
    }

    public override destroy(): void {
        this.removeFromParent();
        super.destroy();
    }
}